export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_MODAL_PROPS = 'SET_MODAL_PROPS';
export const SHOW_VIEW_JSON_MODAL = 'SHOW_VIEW_JSON_MODAL';
